import * as React from 'react'
import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { AccessForSelectFragment } from 'generated/resources/graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import useFormAccessGroup from 'modules/enps/hooks/useAccessGroup'
import type Form from 'modules/enps/store/models/Form'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

interface Props {
  form: Form
  onClose: () => void
}

export default function AddEditorModal({ form, onClose }: Props) {
  const [access, setAccess] = useState<AccessForSelectFragment | null>(null)
  const [running, setRunning] = useState(false)
  const { loading, accessGroup } = useFormAccessGroup(form)

  const submit = async () => {
    if (!accessGroup || !access) {
      return
    }

    setRunning(true)

    const { success } = await asyncAction(() =>
      formAccessGroupMemberships.create({
        access_id: access?.id,
        access_group_id: form.attributes.access_group_id,
        form_id: form.attributes.id,
      })
    )

    setRunning(false)

    if (success) onClose()
  }

  const memberIds = formAccessGroupMemberships.toArray()?.map((m) => m.attributes.access_id) || []

  return (
    <Modal
      title={i18n.t('enps.form.editors.title')}
      description={i18n.t('enps.form.editors.description')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={submit}
      footer={
        <Button disabled={!access || running} type="primary" submit>
          {i18n.t('enps.form.editors.add_editor')}
        </Button>
      }
    >
      {loading && <Loading />}
      {!loading && accessGroup && (
        <AccessSelector
          onSelect={(selectedAccess) => setAccess(selectedAccess)}
          value={access}
          excludeCurrentAccess
          withRegularAccess
          excludeIds={memberIds}
          width="s400"
          terminated={false}
        />
      )}
    </Modal>
  )
}
